<script>
  import { DateTime } from 'luxon';
  import { page } from '$app/stores';
  import { goto } from '$app/navigation';
  import LoginSnack from '$lib/client/shared/login-snack.svelte';

  export let track;
  const alreadyRated = ($page.data.ratings || []).find((r) => r.track === track.id);
  let rating = alreadyRated?.rating || 0;
  let filled = rating;
  let empty = 5 - filled;
  let snackbar;

  function enter(e) {
    filled = this;
    empty = 5 - filled;
  }
  function leave(e) {
    filled = rating;
    empty = 5 - filled;
  }
  async function click(e) {
    if (rating !== this) {
      rating = this;
      const response = await fetch('/api/ratings', {
        method: 'POST',
        body: JSON.stringify({
          date: DateTime.now().toFormat('yyyy-MM-dd'),
          track: track.id,
          rating
        })
      });

      if (response.status === 403) {
        snackbar.open();
      }

      const { showSAF } = await response.json();
      if (showSAF) {
        goto(`/artists/${track.artist.slug}/tracks/${track.id}/asks?threshold=${rating}`);
      }
    }
  }
  let message;
</script>

<div class="rate-now t-uppercase">Rate this track</div>
<div class="stars">
  {#each { length: 5 } as _, i}
    <span
      on:mouseover={enter.bind(i + 1)}
      on:mouseleave={leave.bind(i + 1)}
      on:click|stopPropagation={click.bind(i + 1)}
      class="material-icons"
      class:filled={i < filled}
      title={`Rate ${i + 1} stars`}
    >
      {#if rating > 0 && rating > i}
        star
      {:else}
        star_border
      {/if}
    </span>
  {/each}
</div>

<LoginSnack bind:snackbar />
